<template>
  <ClientOnly>
    <div class="scroll-wrapper">
      <div class="familytree">
        <FamilyTreeNode v-if="root" :node="root" :tree="data" root></FamilyTreeNode>
      </div>
    </div>
  </ClientOnly>
</template>

<script setup lang="ts">
import { normalizeTree, treeGet, type FamilyTree, type Name } from '../familytree/familytree'
import FamilyTreeNode from '../familytree/FamilyTreeNode.vue'

const props = defineProps<{
  root: Name
  data?: FamilyTree
}>()

const people = inject<FamilyTree>('people', {})

const data = computed(() => (props.data ? normalizeTree(props.data) : (people.value as FamilyTree)))

const root = computed(() => treeGet(data.value, props.root))
</script>

<style scoped lang="postcss">
.scroll-wrapper {
  overflow-x: auto;
  padding: 1em;
  margin-top: 1em;
  max-width: 100%;
}

.familytree {
  display: flex;
  gap: 1em;
  margin: auto;
  width: fit-content;
  flex-direction: column;
  align-items: center;
}
</style>
